import { Link } from "react-router-dom";
import solar1 from "../../images/spotlight.png";

function SpotLight() {
  return (
    <section className="relative w-full bg-[#101928] mx-auto overflow-hidden pb-12 xl:pb-0 xl:h-[875px]">
      {/* Header */}
      <div className="w-full max-w-[717px] mx-auto flex flex-col items-center gap-4 px-4 pt-16 xl:p-0 xl:absolute xl:left-1/2 xl:-translate-x-1/2 xl:top-16">
        <h2 className="font-semibold text-[28px] sm:text-[32px] xl:text-[40px] leading-[120%] tracking-[-0.04em] text-white text-center">
          Partner <span className="text-[#0D924F]">Spotlight </span>
        </h2>
        <p className="text-[16px] xl:text-[18px] leading-[21px] text-center text-[#898989] max-w-[603px]">
          Strategic insights for the carbon economy, paired with vetted partners driving real-world sustainability impact.
        </p>
      </div>

      {/* Left content */}
      <div className="w-full max-w-[499px] mx-auto flex flex-col gap-10 px-4 mt-12 xl:mt-0 xl:p-0 xl:absolute xl:left-[120px] xl:top-[280px] xl:w-[499px]">
        <div className="flex flex-col gap-6">
          <h1 className="font-semibold text-[28px] sm:text-[34px] xl:text-[48px] leading-[110%] tracking-[-0.04em] text-white">
            Introducing Low-cost mobility for Nigeria’s transport system - Netzence
          </h1>
          <p className="font-normal text-[16px] xl:text-[20px] leading-[120%] tracking-[-0.02em] text-[#898989]">
            Nigeria’s mobility ecosystem is shifting. Rising fuel prices and congestion have made transportation costs unsustainable for many commuters.
          </p>
          {/* Tags */}
          <div className="flex flex-row flex-wrap items-center gap-3">
            <div className="bg-white/5 border border-[#141414] rounded-full py-2 px-4">
              <span className="text-sm text-[#B1B1B1]">
                Clean Transport
              </span>
            </div>
            <div className="bg-white/5 border border-[#141414] rounded-full py-2 px-4">
              <span className="text-sm text-[#B1B1B1]">
                Nigeria-Wide Support
              </span>
            </div>
          </div>
        </div>
        {/* Button */}
        <Link
          to="/PressAndNews"
          className="flex flex-row justify-center items-center mt-5 py-3 gap-2.5 w-[147px] h-[47px] bg-[#0D924F] border-2 border-[#006633] hover:bg-[#0b7c43] rounded-lg"
        >
          <span className="font-medium text-[16px] text-white">
            Discover more
          </span>
        </Link>
      </div>

      {/* Right image */}
      <div
        className="w-full aspect-[815/541] rounded-l-[26.882px] bg-cover bg-center mt-12 xl:mt-0 xl:absolute xl:left-[725.58px] xl:top-[242px] xl:w-[815.42px] xl:h-[541px]"
        style={{
          backgroundImage: `url(${solar1})`,
        }}
      />
    </section>
  );
}

export default SpotLight;